import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
import api from 'utils/api';
import { getFileExtension } from 'utils/fileType';
import localData from 'utils/localData';
import { IssuePropTypes } from 'shared/propTypes/issueType';
import { AttachmentProptypes } from 'shared/propTypes/attachmentType';
import logger from 'utils/logger';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { USER_DATA } from 'shared/constants/users';
import { isPDF, loadPdfFromPresignedURL } from './utils';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
  attachment: PropTypes.shape(AttachmentProptypes).isRequired,
  modalClose: PropTypes.func,
};

const FILE_TYPE = {
  PDF: 'pdf',
  DOC: 'doc',
  DOCX: 'docx',
  XLS: 'xls',
  XLSX: 'xlsx',
  CSV: 'csv',
};

const log = logger.createLogger('IssueDetailsPreview');

const IssueDetailsPreview = ({ issue, attachment, modalClose }) => {
  const [documentURL, setDocumentURL] = useState(null);
  const [fileType, setFileType] = useState(null);

  useEffect(() => {
    const config = {
      params: {
        organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
        attachmentId: attachment.id,
      },
    };

    api
      .get(`/api/download/${issue.id}`, config)
      .then(async (data) => {
        isPDF(data.GetObjectPresignedURL).then((isPdfFile) => {
          if (isPdfFile) {
            loadPdfFromPresignedURL(data.GetObjectPresignedURL, {}, {}).then(
              (url) => {
                setDocumentURL(url);
                setFileType(FILE_TYPE.PDF);
              }
            );
          } else {
            setDocumentURL(data.GetObjectPresignedURL);
            setFileType(getFileExtension(attachment.title));
          }
        });
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  const documents = documentURL
    ? [
        {
          uri: documentURL,
          fileType: getFileExtension(attachment.title),
          fileName: attachment.title,
        },
      ]
    : [];

  const previewComponent =
    fileType === FILE_TYPE.PDF ? (
      <iframe src={documentURL} width="100%" height="100%" />
    ) : (
      <DocViewer
        key={documentURL}
        documents={documents}
        language="ja"
        pluginRenderers={DocViewerRenderers}
        style={{ height: '100%', width: '100%' }}
        config={{
          header: {
            disableFileName: false,
            retainURLParams: false,
          },
        }}
      />
    );

  return (
    <Grid>
      <Grid container justifyContent="flex-end" sx={{ background: '#525659' }}>
        <div>
          <IconButton onClick={modalClose}>
            <CloseIcon sx={{ color: '#fff' }} />
          </IconButton>
        </div>
      </Grid>
      <Grid
        sx={{
          background: '#525659',
          width: '80vw',
          height: '85vh',
          maxWidth: '100%',
          maxHeight: '100%',
          overflowY: 'hidden',
          '& .pg-viewer-wrapper': {
            overflowY: 'auto !important',
          },
        }}
        columns={{ xs: 12 }}>
        {fileType ? (
          previewComponent
        ) : (
          <div
            style={{
              height: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <CircularProgress />
          </div>
        )}
      </Grid>
    </Grid>
  );
};

IssueDetailsPreview.propTypes = propTypes;

export default IssueDetailsPreview;
